import { useEffect, useState } from "react";

export const ALPHA_URL = "https://alpha.tradrquant.com";
export const VERIFY_URL = "https://verify.tradrquant.com";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let pending = null;
export const useVerifyStats = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    pending = pending || fetch(`${API}/verify/stats`).then((r) => r.json()).catch(() => ({ live: false }));
    pending.then(setS);
  }, []);
  return s;
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.24em] text-[#7D8390] ${className}`}>
    <span className="h-px w-6 bg-white/25" />
    {children}
  </p>
);

export const H2 = ({ children, className = "" }) => (
  <h2 className={`font-display text-3xl font-semibold leading-[1.04] tracking-[-0.03em] text-[#ECEBE4] sm:text-4xl lg:text-5xl ${className}`}>
    {children}
  </h2>
);

export const IMG_SIZE = { "/of/flow.webp": [1600, 1000], "/of/pulse.webp": [1600, 1000], "/of/regime.webp": [1600, 1000], "/of/verify.webp": [1600, 1000], "/of/whales.webp": [1600, 1000], "/of/mobile.webp": [390, 844] };
export const imgSize = (src) => { const [width, height] = IMG_SIZE[src] || [1600, 900]; return { width, height }; };

export const Shot = ({ src, alt, className = "" }) => (
  <div className={`overflow-hidden border border-white/[0.09] bg-[#0D0E11] shadow-[0_40px_100px_-40px_rgba(0,0,0,0.95)] ${className}`}>
    <img src={src} alt={alt} loading="lazy" {...imgSize(src)} className="block h-auto w-full" />
  </div>
);
